import api from './api';

const vaultdownloadsService = {
  getAllVaultDownloads: async (filters = {}) => {
    const params = new URLSearchParams();
    if (filters.vaultid) {
      params.append('vaultid', filters.vaultid);
    }
    if (filters.name) {
      params.append('name', filters.name);
    }
    const queryString = params.toString();
    const url = queryString ? `/vaultdownloads?${queryString}` : '/vaultdownloads';
    return api.get(url);
  },

  getVaultDownloadById: async (id) => {
    return api.get(`/vaultdownloads/${id}`);
  },

  deleteVaultDownload: async (id) => {
    return api.delete(`/vaultdownloads/${id}`);
  },

  generateVaultDownload: async (vaultid, platform) => {
    return api.post(`/vaultdownloads/generate`, { vaultid, platform });
  },

  getPresignedDownloadUrl: async (id) => {
    return api.get(`/vaultdownloads/${id}/download`);
  }
};

export default vaultdownloadsService;
